import { render, staticRenderFns } from "./PromotionAddGroup.vue?vue&type=template&id=17d8100a&scoped=true&"
import script from "./PromotionAddGroup.vue?vue&type=script&lang=js&"
export * from "./PromotionAddGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8100a",
  null
  
)

export default component.exports